declare var jQuery:any;

export class Ajax {
    ajax_url:string;
    nonce:string;
    data:any;

    constructor(ajax_url:string, nonce:string) {
        this.ajax_url = ajax_url;
        this.nonce = nonce;
        this.data = {
            nonce: this.nonce
        };
    }

    public restartData() {
        this.data = {
            nonce: this.nonce
        };
    }

    public setData(key:string, value:any):void {
        this.data[key] = value;
    }

    public getData(key:string):any {
        if (key in this.data) {
            return this.data[key];
        }
        return null;
    }

    public jAjax(url:string, type:string, dataType:string, data:any, onSuccess:any, onError:any) {
        let ajaxArgs:any = {
            type : type,
            dataType : dataType,
            url : url,
            success: onSuccess,
            error: onError,
        }
        if (data) {
            ajaxArgs['data'] = data;
        }
        jQuery.ajax(ajaxArgs);
    }

    public callWPAjax(action:string, onSuccess:any=null, onError:any=null, method:string='post') {
        this.data['action'] = action;
        if (!onSuccess) {
            onSuccess = (resp:any) => {console.log(resp)}
        }
        if (!onError) {
            onError = (err:any) => {console.error(err)}
        }
        this.jAjax(
            this.ajax_url,
            method,
            "json",
            this.data,
            onSuccess,
            onError
        )
    }
}
